import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ListboxGroupMixin } from '../../mixins/components/ListboxGroupMixin';

/**
 * A group of `Listbox` options, similar to a select `<optgroup>`.
 *
 * @since 8.28.0
 */
var ListboxGroup = /*#__PURE__*/styled.ul.withConfig({
  displayName: "ListboxGroup",
  componentId: "c11n-8-107-0__sc-1a0j08-0"
})(["", ""], ListboxGroupMixin);
ListboxGroup.displayName = 'ListboxGroup';
ListboxGroup.propTypes = {
  /**
   * https://www.w3.org/TR/wai-aria-1.2/#aria-labelledby
   */
  'aria-labelledby': PropTypes.string.isRequired,
  /**
   * Uses the ["group"](https://www.w3.org/TR/wai-aria-1.2/#group) role by default.
   */
  'role': PropTypes.string
};
ListboxGroup.defaultProps = {
  role: 'group'
};

/** @component */
export { ListboxGroup };